import { render, staticRenderFns } from "./list.vue?vue&type=template&id=9d6fedbc&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=9d6fedbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6fedbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d6fedbc')) {
      api.createRecord('9d6fedbc', component.options)
    } else {
      api.reload('9d6fedbc', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=9d6fedbc&scoped=true", function () {
      api.rerender('9d6fedbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prizes/list.vue"
export default component.exports